<template>
  <div>
    <div v-show="loading || Object.values(loadingComponents).find(val => val === true)" class="loader-container">
      <div class="loader-wall"></div>
    </div>
    <div id="app" class="loaded-wall" v-show="!loading && !Object.values(loadingComponents).find(val => val === true)">
      <h1-commom v-if="'title' in product" :title="product.title + 'の映画館（上映館）検索'"></h1-commom>
      <h1-commom v-else title="映画館検索"></h1-commom>
      <sns-button></sns-button>
      <h2-commom title="都道府県から映画館を探す"></h2-commom>
      <all-regions @loadedComponents="loadedComponents"></all-regions>
      <h2-commom title="上映中作品"></h2-commom>
      <carousel v-bind:movies="moviesNowShowing" v-bind:addClass="'mb40'"></carousel>
      <h2-commom title="近日公開予定作品"></h2-commom>
      <carousel v-bind:movies="moviesProductCalendarProducts"></carousel>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import Mixin from '../mixin/Mixin'
import ProductApiClass from '../../mixin/js/aukana/product-api'
import CalendarApiClass from '../../mixin/js/aukana/calendar-api'
// common components
import Breadcrumbs from '../components/common/Breadcrumbs'
import H1Commom from '../components/common/h1'
import H2Commom from '../components/common/h2'
import SnsButton from '../components/common/SnsButton'
// theater components
import AllRegions from '../components/theater/AllRegions'
import Carousel from '../components/theater/Carousel'

let ProductApi = new ProductApiClass;
let CalendarApi = new CalendarApiClass;

export default {
  components: {
    Breadcrumbs,
    H1Commom,
    H2Commom,
    SnsButton,
    AllRegions,
    Carousel
  },
  mixins: [Mixin],
  data() {
    return {
      loading: true,
      loadingComponents: {'all-regions': true},
      productSid: '',
      product: {},
      moviesNowShowing: {},
      moviesProductCalendarProducts: {},
      yearMonth: moment().format('YYYYMM'),
    }
  },
  mounted() {
    Promise.all([
        this.fetchNowShowingProducts(),
        this.fetchProductCalendarProducts(),
        this.fetchProduct(),
      ]).then(results => {
        const defaultBreadcrumbs = [];
        if('title' in this.product) {
          // 作品で絞り込んでいたらパンくずにも反映
          const breadcrumbs = JSON.parse(document.querySelector('meta[name="breadcrumbs"]').getAttribute('content'));
          for(const key in breadcrumbs) {
            const breadcrumb = breadcrumbs[key];
            if(key == 0) {
              breadcrumb['label'] = this.product.title + 'の映画館（上映館）検索';
            }
            defaultBreadcrumbs.push(breadcrumb);
          }
        }
        new Vue({
          el: '.breadcrumbs',
          data: {defaultBreadcrumbs: defaultBreadcrumbs},
          template: '<Breadcrumbs v-bind:defaultBreadcrumbs="defaultBreadcrumbs" />',
          components: { Breadcrumbs }
        })
        this.loading = false;
      });
  },
  methods: {
    // 上映中作品
    async fetchNowShowingProducts() {
      const movies = await CalendarApi.getNowShowingProducts();
      this.moviesNowShowing = movies;
    },
    // 近日公開予定作品
    async fetchProductCalendarProducts() {
      const startDay = moment().format('YYYY-MM-DD');
      const endDay = moment().add(3, 'months').format('YYYY-MM-DD');
      const movies = await CalendarApi.getProductCalendarProducts(startDay, endDay);
      this.moviesProductCalendarProducts = movies;
    },
    // 絞り込み作品
    async fetchProduct() {
      this.productSid = document.querySelector('meta#productSid').getAttribute('content');
      if(this.productSid) {
        const product = await ProductApi.getProduct(this.productSid);
        this.product = product;
      }
    }
  }
}
</script>

<style lang='scss'>
  @import '../sass/theater.scss';
</style>